import { useEffect } from "react";

export const useLockHistory = () => {
  // Install once when entering the page you want to “lock”
  useEffect(() => {
    const push = () => history.pushState(null, "", location.href);
    push();
    const onPop = () => history.go(1); // pushes the user forward again
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
};
